import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { AppProvider } from 'app-context';
import { useGetTeacherSpecificSTList } from 'actions/student-transfer/bulk-student';
import { Drawer } from 'comps';

import { StudentTransferWrapper } from '../student-transfer/styles';
import TransferTeacherInfo from './details-info';
import TransferStudentList from './transfer-student-list';

const getTransferTeacherId = pathname => {
  if (typeof pathname !== 'string' || pathname === '') return '';

  const pathNameList = pathname?.split('/') || [];

  return pathNameList[pathNameList.length - 1];
};

const STTeacherDetails = () => {
  const history = useHistory();
  const { location } = history || {};
  const { pathname } = location || {};

  const [sidePanelView, setSidePanelView] = useState({});

  const { get: getTeacherData, data } = useGetTeacherSpecificSTList();

  const transferTeacherId = getTransferTeacherId(pathname);
  const { view } = sidePanelView || {};

  const onEditTransferSlots = props => {
    setSidePanelView({
      view: 'student-transfer-slot-pending',
      title: 'Slot Pending',
      props,
    });
  };

  const makeGetTeacherDataAPICall = useCallback(() => {
    getTeacherData(transferTeacherId, {
      teacher_id: transferTeacherId,
      include_students_regular_slot_details: 'True',
      include_student_primary_course_details: 'True',
      include_teacher_transfer_details: 'True',
    });
  }, [getTeacherData, transferTeacherId]);

  useEffect(() => {
    if (transferTeacherId && !view) {
      makeGetTeacherDataAPICall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferTeacherId, view]);

  return (
    <AppProvider state={{ setSidePanelView, sidePanelView }}>
      <Drawer />
      <StudentTransferWrapper padding="17px 16px 0">
        <TransferTeacherInfo />

        <TransferStudentList
          onEditTransferSlots={onEditTransferSlots}
          transferStudentAPIData={data}
        />
      </StudentTransferWrapper>
    </AppProvider>
  );
};

export default STTeacherDetails;
